"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizationsImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Localizations operations. */
var LocalizationsImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Localizations class.
   * @param client Reference to the service client
   */
  function LocalizationsImpl(client) {
    (0, _classCallCheck2["default"])(this, LocalizationsImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(LocalizationsImpl, [{
    key: "getLocalizations",
    value: function getLocalizations(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getLocalizationsOperationSpec);
    }
  }]);
  return LocalizationsImpl;
}(); // Operation Specifications


exports.LocalizationsImpl = LocalizationsImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getLocalizationsOperationSpec = {
  path: "/api/Portals({portalId})/localizations",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PortalLocalizationModel"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};